import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReduxCompany from '../../../../store/actionreducers/company';
import {FusePageSimple, FuseAnimate} from '../../../../@fuse/index';
import CompanyList from './CompanyList';
import CompanyHeader from './CompanyHeader';
import CompanyDialog from './CompanyDialog';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import {constDataDialogs} from "../../../../constants";
import UecareFAB from "../../../../components/UecareFAB";

class CompaniesApp extends Component {

    async componentDidMount() {
        try {
            await this.props.getCompanies();
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.props.location, prevProps.location)) {
            this.props.getCompanies(this.props.match.params);
        }
    }

    render() {
        const {classes, openDataDialog} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <CompanyHeader pageLayout={() => this.pageLayout}/>
                    }
                    content={
                        <CompanyList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <UecareFAB
                        icon='add'
                        onClick={() => {
                            openDataDialog({type: 'new', name: constDataDialogs.name.companyDialog});
                        }}/>
                </FuseAnimate>
                <CompanyDialog/>
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: 160,
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(null, mapDispatchToProps)(CompaniesApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/company/CompaniesApp.js